import { styled as t } from "@lokalise/styled";
import { spacing as o, value as r } from "../../utils/theme/index.js";
const e = t.div`
	padding: ${o(4)};
	width: 230px;
	display: grid;
	gap: ${o(2)};
`, a = t.button`
	background-color: transparent;
	border: none;
	cursor: pointer;
	font-size: inherit;
	font-weight: inherit;
	font-style: inherit;
	color: inherit;
`, p = t.span`
	color: ${r("color.text.danger")};
	font-style: italic;
`;
export {
  e as Container,
  p as Empty,
  a as Trigger
};
//# sourceMappingURL=styles.js.map
